import { render, staticRenderFns } from "./AdminTopBoxes.vue?vue&type=template&id=01ecbeec&scoped=true&"
import script from "./AdminTopBoxes.vue?vue&type=script&lang=js&"
export * from "./AdminTopBoxes.vue?vue&type=script&lang=js&"
import style0 from "./AdminTopBoxes.vue?vue&type=style&index=0&id=01ecbeec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ecbeec",
  null
  
)

export default component.exports